// 101 Candies --- not filled
// 25 Cookies: Hit The Bonus ---- done
// 3 African Drums -----done
// 3 Chillies And Joker Hold And Win ---- done
// 3 China Pots ----done
// 3 Coin Volcanoes ---- done
// 3 Hot Chillies ---- done
// 3 Jewel Crowns -- not filled -- done
// 3 Luxor Pots: Hold And Win ---- done
// 3 Magic Lamps: Hold And Win --- not filled -- done
// 3 Pots Of Egypt --- not filled -- done
// 777 Coins --- not filled -- done
// Aztec Fire 2 --- not filled -- done
// Big Bad Bison --- not filled -- done

// 06.03.2026 release
// Big Bang Boom -- done
// Big Gains - done
// Charge The Clovers: Hit The Bonus -- done
// Coin Express - done
// Coin Up: Hot Fire - done
// Coin Volcano - done
// Crab Trap 94 -- not filled
// Egypt Fire - Threeoaks - done
// Finn And The Candy Spin - done

// release 26.03.2026
// Fire In The Hole 3
// Fireworks Megaways
// Aviamasters
// Gator Hunters
export const SlotsFilledAliases = [
  'gator-hunters',
  'fire-in-the-hole-3',
  'finn-and-the-candy-spin-netent',
  'coin-volcano',
  'coin-express',
  'charge-the-clovers-hit-the-bonus',
  'big-gains-evtn',
  'big-bang-boom',
  '3-jewel-crowns',
  '3-magic-lamps-hold-and-win',
  '3-luxor-pots-hold-and-win',
  '3-african-drums',
  '3-coin-volcanoes',

  'fireworks-megaways',
  'aviamasters',
  'egypt-fire',
  'coin-up-hot-fire',
  '3-pots-of-egypt',
  '777-coins',
  'aztec-fire-2',
  'big-bad-bison',
  '3-hot-chillies',
  '3-chillies-and-joker-hold-and-win',
  '3-china-pots',
  '25-cookies-hit-the-bonus',
];
export const TopGamesAliasLabels = {
  // Top games category
  'big-gains-evtn': 'Big Gains',
  'finn-and-the-candy-spin-94': 'Finn And The Candy Spin 94',
  '3-african-drums': '3 African Drums',
  '3-coin-volcanoes': '3 Coin Volcanoes',
  'coin-volcano': 'Coin Volcano',
  'coin-up-hot-fire': 'Coin Up: Hot Fire',
  '3-hot-chillies': '3 Hot Chillies',

  // Other games category
  'gator-hunters': 'Gator Hunters 94',
  'fireworks-megaways': 'Fireworks Megaways',
  'fire-in-the-hole-3': 'Fire In The Hole 3',
  'aviamasters': 'Aviamasters',
  'egypt-fire': 'Egypt Fire',
  'charge-the-clovers-hit-the-bonus': 'Charge The Clovers: Hit The Bonus',
};
